var HSForm_PhoneVerification = new Object();

HSForm_PhoneVerification.version = "1.0.2";
HSForm_PhoneVerification.$form = null;

HSForm_PhoneVerification.init = function ($form, style, enabled) {
  this.$form = $form;

  if (helpers.shouldDebug("hsForm")) console.log("[HSForm.PhoneVerification] enabled:", enabled);

  const $phoneField = $form.find(
    'input[name="phone_input_only"],input[name="phone"],input[name="referral_client_phone_number"]',
  );
  const $phoneHidden = $form.find('input[name="phone"]');
  const phonePlaceholder =
    thryvSettings.thryvCountry === "AU"
      ? "0491 570 006"
      : thryvSettings.thryvCountry === "NZ"
        ? "0211 234 567"
        : "(555) 123-4567";
  const phoneMaxChars =
    thryvSettings.thryvCountry === "AU" ? 12 : thryvSettings.thryvCountry === "NZ" ? 13 : 14;

  if (helpers.shouldDebug("hsForm")) console.log("[HSForm.PhoneVerification] init", $phoneField);
  $phoneField.attr("maxlength", phoneMaxChars);
  if (style === "1") {
    $phoneField.attr("placeholder", phonePlaceholder);
  }

  const areaCodes = ["020", "021", "022", "027"];
  const phoneMask =
    thryvSettings.thryvCountry === "AU" ||
    (thryvSettings.thryvCountry === "NZ" && !areaCodes.includes(phoneFormatted.substring(0, 3)))
      ? /^[0-9]{4}.[0-9]{3}.[0-9]{3}$/
      : thryvSettings.thryvCountry === "NZ" && areaCodes.includes(phoneFormatted.substring(0, 3))
        ? /^[0-9]{3}.[0-9]{3}.[0-9]{4,5}$/
        : /^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})$/;

  if (helpers.shouldDebug("hsForm"))
    console.log("[HSForm.PhoneVerification] phoneMask:", phoneMask);

  const showPhoneError = () => {
    $phoneField.addClass("invalid error");
    const $errorBlock = $phoneField.closest(".input").next(".hs-error-msgs");

    const errorHTML = `
      <ul class="no-list hs-error-msgs inputs-list" role="alert">
        <li>
          <label class="hs-error-msg hs-main-font-element">
            Please enter a valid business phone number.
          </label>
        </li>
      </ul>
    `;

    if ($errorBlock.length <= 0) {
      $phoneField.closest(".input").after(errorHTML);
    } else {
      $errorBlock.html(errorHTML);
    }
  };

  const clearPhoneError = () => {
    $phoneField.removeClass("invalid error");
    $phoneField.closest(".input").next(".hs-error-msgs").remove();
  };

  if (helpers.shouldDebug("hsForm"))
    console.log("[HSForm.PhoneVerification] enabled:", enabled ? "true" : "false");

  const isPhoneValid = (phoneFormatted) => {
    const oldPhone = sessionStorage.getItem("twilio_phone_number");
    const isValidStored = !enabled ? "true" : sessionStorage.getItem("twilio_phone_number_valid");

    if (helpers.shouldDebug("hsForm")) {
      console.log("[HSForm.PhoneVerification] oldPhone:", oldPhone);
      console.log("[HSForm.PhoneVerification] phoneFormatted:", phoneFormatted);
    }

    if (enabled && (!oldPhone || oldPhone !== phoneFormatted)) {
      sessionStorage.setItem("twilio_phone_number", phoneFormatted);

      const twilioSettings = {
        type: "POST",
        url: thryvData.ajax_url,
        data: {
          phone: phoneFormatted,
          action: "twilioPhoneLookup",
        },
        beforeSend: function () {
          if (helpers.shouldDebug("hsForm"))
            console.info("[HSForm.PhoneVerification] twilio lookup called");
        },
      };

      return jQuery
        .ajax(twilioSettings)
        .done((response) => {
          if (response?.data) {
            const lookup_info = JSON.parse(response.data);
            if (helpers.shouldDebug("hsForm"))
              console.log("[HSForm.PhoneVerification] lookup_info:", lookup_info);

            const valid_types = ["mobile", "voip", "fixedVoip", "landline"];
            if (
              lookup_info?.valid &&
              valid_types.includes(lookup_info?.line_type_intelligence?.type)
            ) {
              sessionStorage.setItem("twilio_phone_number_valid", "true");
              clearPhoneError();
            } else {
              sessionStorage.setItem("twilio_phone_number_valid", "false");
              showPhoneError();
            }
          }
        })
        .fail((xhr, status, error) => {
          console.error("[HSForm.PhoneVerification] twilio lookup failed:", xhr, status, error);
          showPhoneError();
        });
    }

    return isValidStored === "true";
  };

  $phoneField.on("keyup keydown blur input change", (e) => {
    const $currPhoneField = $(e.target);
    const rawVal = $currPhoneField.val();
    if (helpers.shouldDebug("hsForm")) console.log("[HSForm.PhoneVerification] rawVal:", rawVal);
    const isMainPhoneField =
      $currPhoneField.attr("name") === "phone" ||
      $currPhoneField.attr("name") === "phone_input_only";
    const phoneFormatted = HSForm_PhoneVerification.formatPhone(
      HSForm_PhoneVerification.numOnly(rawVal),
    );
    $currPhoneField.val(phoneFormatted);

    if (isMainPhoneField) {
      $phoneHidden.val(phoneFormatted);
      if (!phoneMask.test(phoneFormatted)) {
        showPhoneError();
        return;
      }

      const isValid = isPhoneValid(phoneFormatted);

      if (!isValid) {
        if (helpers.shouldDebug("hsForm"))
          console.log("[HSForm.PhoneVerification] isPhoneValid called");
        showPhoneError();
      } else {
        clearPhoneError();
      }
    }
  });
};

HSForm_PhoneVerification.numOnly = function (n, allowDecimal = false, max = false) {
  if (typeof n !== "string") n = String(n);

  if (max !== false) {
    const maxVal = typeof max === "number" ? max.toString() : String(max);
    if (parseFloat(n) > parseFloat(maxVal)) {
      n = maxVal;
    }
  }

  if (!allowDecimal) {
    return n.replace(/[^0-9]/g, "");
  } else {
    const formatNum = n.replace(/[^0-9.]/g, "");
    const parts = formatNum.split(".");
    const beforeDecimal = parts[0];
    const afterDecimal = parts[1] ? parts[1].slice(0, 2) : "";

    return beforeDecimal + (afterDecimal !== "" ? "." + afterDecimal.padEnd(2, "0") : "");
  }
};

HSForm_PhoneVerification.formatPhone = function (inputVal, country = thryvSettings.thryvCountry) {
  var phone = new String(inputVal);
  if (country === "AU" || country === "AU") {
    phone = phone.substring(0, 12);
    if (phone.match("[0-9]{4}.[0-9]{3}.[0-9]{3}") == null) {
      var i;
      var phoneNumeric = (phoneChar = "");
      for (i = 0; i < phone.length; i++) {
        // Go thru what user has entered one character at a time.
        var phoneChar = phone.substr(i, 1);
        if (!isNaN(phoneChar) && phoneChar != " ") phoneNumeric = phoneNumeric + phoneChar;
      }
      phone = "";
      for (i = 0; i < phoneNumeric.length; i++) {
        // If you are on the 4th digit, put ') ' before that.
        if (i == 4) phone = phone + " ";
        // If you are on the 7th digit, insert '-' before that.
        if (i == 7) phone = phone + " ";
        // Add the digit to the phone charatcer string you are building.
        phone = phone + phoneNumeric.substr(i, 1);
      }
    } else {
      // console.log("test");
      phone = phone.substring(0, 4) + " " + phone.substring(5, 8) + " " + phone.substring(9, 13);
    }
    if (phone != inputVal) inputVal = phone;
  } else if (country === "NZ") {
    phone = phone.substring(0, 13);
    let areaCodes = ["020", "021", "022", "027"];

    if (
      areaCodes.includes(phone.substring(0, 3)) &&
      phone.match("[0-9]{3}.[0-9]{3}.[0-9]{4,5}") == null
    ) {
      var i;
      var phoneNumeric = (phoneChar = "");
      for (i = 0; i < phone.length; i++) {
        // Go thru what user has entered one character at a time.
        var phoneChar = phone.substr(i, 1);
        if (!isNaN(phoneChar) && phoneChar != " ") phoneNumeric = phoneNumeric + phoneChar;
      }
      phone = "";
      for (i = 0; i < phoneNumeric.length; i++) {
        // If you are on the 4th digit, put ') ' before that.
        if (i == 3) phone = phone + " ";
        // If you are on the 7th digit, insert '-' before that.
        if (i == 6) phone = phone + " ";
        // Add the digit to the phone charatcer string you are building.
        phone = phone + phoneNumeric.substr(i, 1);
      }
    } else if (phone.match("[0-9]{4}.[0-9]{3}.[0-9]{3}") == null) {
      var i;
      var phoneNumeric = (phoneChar = "");
      for (i = 0; i < phone.length; i++) {
        // Go thru what user has entered one character at a time.
        var phoneChar = phone.substr(i, 1);
        if (!isNaN(phoneChar) && phoneChar != " ") phoneNumeric = phoneNumeric + phoneChar;
      }
      phone = "";
      for (i = 0; i < phoneNumeric.length; i++) {
        // If you are on the 4th digit, put ') ' before that.
        if (i == 4) phone = phone + " ";
        // If you are on the 7th digit, insert '-' before that.
        if (i == 7) phone = phone + " ";
        // Add the digit to the phone charatcer string you are building.
        phone = phone + phoneNumeric.substr(i, 1);
      }
    } else {
      phone = areaCodes.includes(phone.substring(0, 3))
        ? phone.substring(0, 3) + " " + phone.substring(4, 9) + " " + phone.substring(8, 14)
        : phone.substring(0, 4) + " " + phone.substring(5, 8) + " " + phone.substring(9, 13);
    }
    if (phone != inputVal) inputVal = phone;
  } else {
    phone = phone.substring(0, 14);
    if (phone.match(".[0-9]{3}.[0-9]{3}-[0-9]{4}") == null) {
      if (
        phone.match(
          ".[0-9]{2}.[0-9]{3}-[0-9]{4}|" +
            ".[0-9].[0-9]{3}-[0-9]{4}|" +
            ".[0-9]{3}.[0-9]{2}-[0-9]{4}|" +
            ".[0-9]{3}.[0-9]-[0-9]{4}",
        ) == null
      ) {
        var i;
        var phoneNumeric = (phoneChar = "");
        // Loop thru what user has entered.
        for (i = 0; i < phone.length; i++) {
          // Go thru what user has entered one character at a time.
          var phoneChar = phone.substr(i, 1);
          if (!isNaN(phoneChar) && phoneChar != " ") phoneNumeric = phoneNumeric + phoneChar;
        }
        phone = "";
        for (i = 0; i < phoneNumeric.length; i++) {
          // If it's the first digit, throw in '(' before that.
          if (i == 0) phone = phone + "(";
          // If you are on the 4th digit, put ') ' before that.
          if (i == 3) phone = phone + ") ";
          // If you are on the 7th digit, insert '-' before that.
          if (i == 6) phone = phone + "-";
          // Add the digit to the phone charatcer string you are building.
          phone = phone + phoneNumeric.substr(i, 1);
        }
      }
    } else {
      // This means the tel no is in proper format. Make sure by replacing the 0th, 4th and 8th character.
      phone =
        "(" + phone.substring(1, 4) + ") " + phone.substring(5, 8) + "-" + phone.substring(9, 13);
    }
    // So far you are working internally. Refresh the screen with the re-formatted value.
    if (phone != inputVal) inputVal = phone;
  }
  return phone;
};

export default HSForm_PhoneVerification;
